import { Input, Directive } from '@angular/core';

export declare interface ILoadable {
  loading: boolean;
}

@Directive()
export class Loadable implements ILoadable {
  @Input() loading: boolean = false;
}
